import React, { useEffect, useState } from "react"
import {
  Table,
  Button,
  Modal,
  Popconfirm,
  Input,
  notification,
  Icon,
  Divider,
} from "antd"

import { AuthActions } from "redux-store/models"

import { connect } from "react-redux"
import { endpoint } from "../../config/api"

const AttributesPage = ({ accountInfo }) => {
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(false)
  const [confirmLoading, setConfirmLoading] = useState(false)
  const [visible, setVisible] = useState(false)
  const [editingItem, setEditingItem] = useState(null)

  const [name, setName] = useState("")
  const [values, setValues] = useState([{ id: null, value: "" }])

  const token = accountInfo?.token

  const fetchData = async () => {
    setLoading(true)
    try {
      const res = await fetch(`${endpoint}attributes`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      })

      if (!res.ok) throw new Error()

      const json = await res.json()
      setData(json)
    } catch (e) {
      notification["error"]({
        message: "Errore",
        description: "Impossibile caricare gli attributi.",
        placement: "bottomRight",
      })
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchData()
  }, [])

  const openModal = (item = null) => {
    if (item) {
      setEditingItem(item)
      setName(item.name)
      const formattedValues = item.values.map((v) =>
        typeof v === "object"
          ? { id: v.id, value: v.value }
          : { id: null, value: v },
      )
      setValues(formattedValues)
    } else {
      setEditingItem(null)
      setName("")
      setValues([{ id: null, value: "" }])
    }
    setVisible(true)
  }

  const handleValueChange = (index, newVal) => {
    const copy = [...values]
    copy[index].value = newVal
    setValues(copy)
  }

  const addValueField = () => setValues([...values, { id: null, value: "" }])

  const removeValueField = (index) => {
    if (values.length === 1) {
      setValues([{ id: null, value: "" }])
    } else {
      setValues(values.filter((_, i) => i !== index))
    }
  }

  const handleSave = async () => {
    if (!name.trim()) {
      return notification["warning"]({ message: "Inserire un nome per l'attributo" })
    }

    setConfirmLoading(true)
    const payload = {
      name,
      values: values.filter((v) => v.value.trim() !== "").map((v) => v.value), // 🔥 ONLY STRING
    }

    const url = editingItem
      ? `${endpoint}attributes/${editingItem.id}`
      : `${endpoint}attributes`

    const method = editingItem ? "PUT" : "POST"

    try {
      const res = await fetch(url, {
        method,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      })

      if (res.ok) {
        notification["success"]({
          message: editingItem ? "Aggiornato con successo!" : "Creato con successo!",
          placement: "bottomRight",
        })
        setVisible(false)
        fetchData()
      } else {
        throw new Error()
      }
    } catch (e) {
      notification["error"]({
        message: "Errore di salvataggio",
        description: "Controlla i dati inseriti e riprova.",
        placement: "bottomRight",
      })
    } finally {
      setConfirmLoading(false)
    }
  }

  const handleDelete = async (id) => {
    setLoading(true)
    try {
      const res = await fetch(`${endpoint}attributes/${id}`, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })

      if (!res.ok) throw new Error()

      notification["success"]({
        message: "Eliminato con successo!",
        placement: "bottomRight",
      })

      fetchData()
    } catch (e) {
      notification["error"]({
        message: "Errore",
        description: "Impossibile eliminare l'attributo.",
        placement: "bottomRight",
      })
    } finally {
      setLoading(false)
    }
  }

  const columns = [
    {
      title: "Nome",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Valori",
      key: "values",
      render: (record) => (
        <span>
          {record.values.map((v, i) => (
            <span key={v.id || i} className="attribute-tag">
              {v.value || v}
            </span>
          ))}
        </span>
      ),
    },
    {
      title: "Azioni",
      key: "actions",
      render: (record) => (
        <span>
          <a onClick={() => openModal(record)}>Modifica</a>
          <Divider type="vertical" />
          <Popconfirm
            title="Eliminare questo attributo?"
            onConfirm={() => handleDelete(record.id)}
            okText="Sì"
            cancelText="No"
          >
            <a style={{ color: "#f5222d" }}>Elimina</a>
          </Popconfirm>
        </span>
      ),
    },
  ]

  return (
    <div className="attributes-container">
      <div className="header-section">
        <h1 style={{ margin: 0 }}>Attributi Prodotto</h1>
        <Button type="primary" icon="plus" onClick={() => openModal()}>
          Aggiungi Attributo
        </Button>
      </div>

      <Table
        className="modern-table"
        dataSource={data}
        columns={columns}
        loading={loading}
        rowKey="id"
        pagination={false}
        scroll={{ y: "calc(100vh - 240px)" }}
      />

      <Modal
        className="attributes-modal"
        title={editingItem ? "Modifica Attributo" : "Nuovo Attributo"}
        visible={visible}
        onCancel={() => setVisible(false)}
        onOk={handleSave}
        confirmLoading={confirmLoading}
        destroyOnClose
        okText="Salva"
        cancelText="Annulla"
      >
        <div style={{ marginBottom: 16 }}>
          <div>Nome Attributo</div>
          <Input
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="es. Taglia, Colore"
          />
        </div>

        <div>Valori</div>
        {values.map((v, i) => (
          <div key={i} className="value-input-wrapper">
            <Input
              value={v.value}
              onChange={(e) => handleValueChange(i, e.target.value)}
              placeholder="Nome valore (es. Rosso, XL)"
              className="modern-input"
              suffix={
                values.length > 1 ? (
                  <Icon
                    type="delete"
                    className="dynamic-delete-button"
                    onClick={() => removeValueField(i)}
                  />
                ) : null
              }
            />
          </div>
        ))}

        <Button type="dashed" icon="plus" onClick={addValueField} block>
          Aggiungi Valore
        </Button>
      </Modal>
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    accountInfo: state.auth.accountInfo,
  }
}

export default connect(mapStateToProps, AuthActions)(AttributesPage)
